module.exports = __webpack_public_path__ + "img/iconimage.ca2eb1ab.svg";